const ScrollWrapper = ({ children, direction = "overflow-y-auto" }) => {
  return (
      <div className="h-full w-full overflow-hidden flex min-h-0">
          <div className={`h-full w-full flex flex-col min-h-0 ${direction}`}>
              {children}
          </div>
      </div>
  );
}
export default ScrollWrapper;